import usePostHogIdentify from "@ch/helpers/utils/postHogAnalytics/usePostHogIdentify";
import useSentryIdentify from "@ch/helpers/utils/sentry/useSentryIdentify";

const AnalyticsIdentify = () => {
  usePostHogIdentify();
  useSentryIdentify();

  return null;
};

export default AnalyticsIdentify;
